import { render, staticRenderFns } from "./CommentsTable.vue?vue&type=template&id=7880ac42"
import script from "./CommentsTable.vue?vue&type=script&lang=js"
export * from "./CommentsTable.vue?vue&type=script&lang=js"
import style0 from "./CommentsTable.vue?vue&type=style&index=0&id=7880ac42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
